import {getSupportedLanguages, setLocale} from 'localization/i18n'
import {useI18n} from 'store/Store'

const UseLanguageButton = ({close}) => {
    const {language: currentLanguage} = useI18n()
    const supportedLanguages = getSupportedLanguages()

    const availableLanguages = supportedLanguages.filter(
        (lanaguage) => currentLanguage !== lanaguage
    )

    const handleSetLanguage = (lang) => {
        setLocale(lang)
        close?.()
    }

    return {
        handleSetLanguage,
        availableLanguages,
        currentLanguage,
    }
}

export default UseLanguageButton
